import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { useSelector as useAppSelector, useDispatch as useAppDispatch, TypedUseSelectorHook } from 'react-redux';
// slices
import { loggedin, token, account, group, devices, device, rangesLocationSensors, rangesLocationPredictions, rangesSensor, rangesRecentlySensor, rangesAnalysis, loader } from './slices';

// ----------------------------------------------------------------------

type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;

export const useSelector: TypedUseSelectorHook<RootState> = useAppSelector;
export const useDispatch: () => AppDispatch = useAppDispatch;

export {
  SET_LOGGEDIN, DELETE_LOGGEDIN,
  SET_TOKEN, DELETE_TOKEN,
  SET_ACCOUNT, DELETE_ACCOUNT,
  SET_GROUP, DELETE_GROUP,
  SET_DEVICES, DELETE_DEVICES,
  SET_DEVICE, DELETE_DEVICE,
  SET_RANGES_LOCATION_SENSORS, DELETE_RANGES_LOCATION_SENSORS,
  SET_RANGES_LOCATION_PREDICTIONS, DELETE_RANGES_LOCATION_PREDICTIONS,
  SET_RANGES_SENSOR, DELETE_RANGES_SENSOR,
  SET_RANGES_RECENTLY_SENSOR, DELETE_RANGES_RECENTLY_SENSOR,
  SET_RANGES_ANALYSIS, DELETE_RANGES_ANALYSIS,
  SET_LOADER, DELETE_LOADER
} from './slices';

// ----------------------------------------------------------------------

const config = { key: 'root', storage, whitelist: ['loggedin'] };

const reducer = combineReducers({
  loggedin: loggedin.reducer,
  token: token.reducer,
  account: account.reducer,
  group: group.reducer,
  devices: devices.reducer,
  device: device.reducer,
  rangesLocationSensors: rangesLocationSensors.reducer,
  rangesLocationPredictions: rangesLocationPredictions.reducer,
  rangesSensor: rangesSensor.reducer,
  rangesRecentlySensor: rangesRecentlySensor.reducer,
  rangesAnalysis: rangesAnalysis.reducer,
  loader: loader.reducer
});

const store = configureStore({
  reducer: persistReducer(config, reducer),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false })
});

export const persistor = persistStore(store);
export default store;